export default "__VITE_ASSET__8M8exWSb__"